import config from "../../../config/config";

/** Backend paths from `APP_CONFIG.API_ROUTES` (mounted in backend/index.js). */
export const SCHEDULE_API_ROUTES = {
  schedules: `${config.BASE_URL}/schedules`,
  scheduleTypes: `${config.BASE_URL}/schedule-types`,
  scheduleStatuses: `${config.BASE_URL}/schedule-statuses`,
  priorityTypes: `${config.BASE_URL}/priority-types`,
  staffSearch: `${config.BASE_URL}/schedules/staff/search`,
};

/** App paths under `/app` (registered in screenRegistry). */
export const SCHEDULE_APP_PATHS = {
  control: "schedules/control",
  entry: "schedules",
};
